export default __webpack_public_path__ + "static/media/logo-yay-white.adbc45dc.svg";